//@flow
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { Link, Text } from 'trpc-react-native-ui';
import { getRenewalDate } from '../../../lib/date-utils';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';
import SubscriptionDetails from '../../subscription/SubscriptionDetails';

class NextPlanDetails extends Component<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    return (
      <View style={styles.nextPlanContainer}>
        <View style={styles.linkContainer}>
          <Link text={I18n.t('cancel').toUpperCase()} onPress={this.props.cancelPlanRequest} style={styles.link} />
        </View>
        <Text style={styles.text}>{I18n.t('nextPlanTitle', { date: getRenewalDate(this.props.renewalDate) })}</Text>
        <SubscriptionDetails
          style={styles.detailedContainer}
          options={this.props.options}
          planCharacteristics={this.props.planCharacteristics}
          nextPlanVouchers={this.props.nextPlanVouchers}
        />
      </View>
    );
  }
}

const getStyles = () => {
  return StyleSheet.create({
    detailedContainer: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 25,
      paddingRight: 25,
    },
    nextPlanContainer: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 25,
      paddingRight: 15,
      backgroundColor: '#eeeeee',
    },
    linkContainer: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      marginBottom: 6,
    },
    link: {
      color: theme.errorColor,
      fontSize: 13,
    },
    text: {
      marginBottom: 5,
    },
  });
};

type Props = {
  renewalDate: number,
  options: Object[],
  planCharacteristics: Object,
  cancelPlanRequest: Function,
  nextPlanVouchers?: Object[],
};

export default NextPlanDetails;
